export const TASK_STATE = {
    EMPTY: "empty",
    RECEIVED: "task-received",
    STARTED: "task-started",
    PROGRESS: "task-progress",
    SUCCESS: "task-finished-success",
    FAILURE: "task-finished-failure",
}

/**
 * Tâche Franz : récupération / reconstruction des données d’une source
 * (équivalent legacy `workers2app.getlastdata_updateapp.request` / REBUILD_SOURCE_DATA).
 */
export const TASK_REBUILD_SOURCE_DATA =
    "workers2app.getlastdata_updateapp.request"
